module.exports = __webpack_public_path__ + "img/icon_video.e76f52ff.svg";